
import { loadScript, waitForElementToMountInDOM } from '~/fc/Helpers/DOMHelper'
import { stringToRegex } from '~/fc/Helpers/StringHelpers';

export default {
    name: 'ColorInput',
    components: {
        ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip')
    },
    props: ['value', 'field', 'selection'],
    data: () => ({
        colors: {
            hex: '#000000'
        },
        colorValue: '',
        displayPicker: false,
        chromeComponent: null,
        isValid: true
    }),
    computed: {
        fullLayout() { return this.field.customVariables && this.field.customVariables.layout === 'full' },
        advancedOptionListResponsiveView() { return this.$store.state.store.advancedOptionListResponsiveView }
    },
    watch: {
        colorValue(val) {
            // checks if rgba. If so, converts rgba to hex before sending to back-end
            if (!val) return;
            if (val.slice(0, 4) == 'rgba') this.$emit('input', this.rgbaToHex(val))
            else this.$emit('input', val)
            this.isValid = stringToRegex(this.field.validation_regex).test(val)
        }
    },
    mounted() {
        this.initializeColorPicker()
    },
    methods: {
        initializeColorPicker() {
            this.loadVueColor((VueColor) => { this.chromeComponent = VueColor.Chrome })
            this.setColor(this.value || '#FFFFFF')
            this.$bus.$on('resetSelection', () => { this.setColor('#FFFFFF') })
            const self = this 
            window.addEventListener('scroll', function () {
                self.adjustColorPicker()
            })
        },
        adjustColorPicker () {
            if(!document.querySelector('.vc-chrome[role="application"]')) return;
            const colorInput = document.getElementById(this.field.id)
            const elementRect = colorInput.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const advancedOptionsFormBottom = document.querySelector('.advanced-option__form')?.getBoundingClientRect()?.bottom || null
            const distanceToBottom = viewportHeight - elementRect.bottom;
            const distanceToFormBottom = advancedOptionsFormBottom - elementRect.bottom;
            if (distanceToBottom < 280 || distanceToFormBottom < 280 ) document.querySelector('.vc-chrome[role="application"]').classList.add('vc-color-top')
            else document.querySelector('.vc-chrome[role="application"]').classList.remove('vc-color-top')
        },
        onSelect(e) {
            this.$emit('input', this.dataValue + '|' + e.target.value)
        },
        setColor(color) {
            this.updateColors(color)
            this.colorValue = color
        },
        updateColors(color) {
            if (color.slice(0, 1) == '#') this.colors = { hex: color } 
            else if (color.slice(0, 4) == 'rgba') this.colors = { hex: this.rgbaToHex(color), a: rgba[3] }
        },
        showPicker() {
            document.addEventListener('click', this.documentClick)
            this.displayPicker = true
            waitForElementToMountInDOM('.vc-chrome[role="application"]', () => {this.adjustColorPicker()})
        },
        hidePicker() {
            document.removeEventListener('click', this.documentClick)
            this.displayPicker = false
        },
        togglePicker() {
            this.displayPicker ? this.hidePicker() : this.showPicker()
        },
        updateFromInput() {
            this.updateColors(this.colorValue)
        },
        updateFromPicker(color) {
            this.colors = color
            if (color.rgba.a == 1) this.colorValue = color.hex
            else this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
        },
        documentClick(e) {
            const el = this.$refs.colorpicker
            const target = e.target
            if (!el) return;
            if (el !== target && !el.contains(target)) this.hidePicker()
        },
        rgbaToHex(color) {
            const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
            const outParts = [
                rgba[0].toString(16),
                rgba[1].toString(16),
                rgba[2].toString(16),
                Math.round(rgba[3] * 255).toString(16).substring(0, 2)
            ]
            outParts.forEach((part, i) => {
                if (part.length === 1) outParts[i] = '0' + part
            })
            return '#' + outParts.join('')
        },
        loadVueColor(callback) {
            if (window.VueColor) callback(window.VueColor)
            else loadScript('https://cdnjs.cloudflare.com/ajax/libs/vue-color/2.8.1/vue-color.min.js', 'vue-color', () => {
                    callback(window.VueColor)
                })
        }
    }
}
